var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGeotreeLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 46,
    viewBox: "0 0 193 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2112_7428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.4984 11.8627H75.3717V28.5739C75.3323 35.1284 70.9127 39.3407 64.3032 39.3407C61.6199 39.3407 58.4236 38.6911 56.1941 37.7267V33.6719C58.1474 34.7151 61.2647 35.404 63.8691 35.404C67.7559 35.404 70.2814 33.1798 70.4787 29.3219C68.9792 30.8178 66.5524 31.7823 63.9875 31.7823C58.759 31.7823 54.3789 27.944 54.3789 21.665C54.3789 15.386 58.759 11.4297 63.9875 11.4297C66.5918 11.4297 68.9792 12.4729 70.4787 13.9492V11.8627H70.4984ZM65.0924 27.7078C66.9667 27.7078 69.0778 26.7827 70.4984 25.3655V17.8661C69.0778 16.4489 66.9667 15.5238 65.0924 15.5238C62.0145 15.5238 59.3706 17.8268 59.3312 21.606C59.3706 25.4246 62.0145 27.7078 65.0924 27.7078Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6937 21.1712C98.6937 21.5846 98.6542 22.0963 98.6147 22.3916H84.3696C84.7839 25.9149 87.1713 27.9029 90.6635 27.9029C92.7352 27.9029 95.5368 27.2534 97.4901 26.3676V30.2059C95.8723 31.0916 92.8338 31.8593 90.0716 31.8593C83.4226 31.8593 79.6738 27.3715 79.6738 21.4862C79.6738 15.1678 83.9355 11.4083 89.5783 11.4083C95.4777 11.3886 98.7331 15.5024 98.6937 21.1712ZM84.6064 19.2422H94.0571C93.7019 16.7818 92.1433 15.3056 89.5981 15.3056C87.0924 15.3056 85.218 16.8015 84.6064 19.2422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.574 21.6279C101.574 15.6442 106.29 11.3926 112.209 11.3926C118.128 11.3926 122.843 15.6442 122.843 21.6279C122.843 27.5723 118.128 31.8633 112.209 31.8633C106.29 31.8633 101.574 27.5723 101.574 21.6279ZM117.97 21.6279C117.97 18.2227 115.366 15.6835 112.209 15.6835C109.091 15.6835 106.487 18.203 106.487 21.6279C106.487 25.0528 109.091 27.5723 112.209 27.5723C115.366 27.5723 117.97 25.0331 117.97 21.6279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.054 30.5208V31.564C137.206 31.7608 136.259 31.8789 135.331 31.8789C130.063 31.8789 127.834 28.3162 127.834 23.6119V6.60548L128.761 5.71973H128.998V11.8412H137.798V12.9042H128.998V23.4741C128.998 26.2691 129.768 30.757 135.568 30.757C136.436 30.7766 137.285 30.6585 138.054 30.5208Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.584 11.4319V12.4752H150.13C147.821 12.4752 145.177 13.853 143.441 15.841V31.3909H142.297V11.865H143.441V14.5419C145.177 12.7507 147.861 11.3926 150.169 11.3926C150.307 11.3926 150.505 11.3926 150.584 11.4319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.424 20.7422V21.4311C153.424 27.0605 156.916 30.7807 161.868 30.7807C163.94 30.7807 166.544 30.1311 168.636 29.0485V30.1902C166.9 31.194 164.137 31.8436 161.868 31.8436C156.028 31.8436 152.26 27.7101 152.26 21.4705C152.26 15.2702 156.068 11.3926 161.355 11.3926C166.584 11.3926 169.681 15.1915 169.681 20.3485C169.681 20.5453 169.681 20.7028 169.642 20.7225H153.424V20.7422ZM153.522 19.7186H168.537C168.3 15.467 165.657 12.4752 161.355 12.4752C157.212 12.4752 154.154 15.1915 153.522 19.7186Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.811 20.7422V21.4311C174.811 27.0605 178.303 30.7807 183.255 30.7807C185.327 30.7807 187.931 30.1311 190.022 29.0485V30.1902C188.286 31.194 185.524 31.8436 183.255 31.8436C177.415 31.8436 173.646 27.7101 173.646 21.4705C173.646 15.2702 177.454 11.3926 182.742 11.3926C187.971 11.3926 191.068 15.1915 191.068 20.3485C191.068 20.5453 191.068 20.7028 191.029 20.7225H174.811V20.7422ZM174.929 19.7186H189.944C189.707 15.467 187.063 12.4752 182.762 12.4752C178.599 12.4752 175.541 15.1915 174.929 19.7186Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.4863 43.0843V37.6123H94.2091V38.2225H92.1966V39.9546H94.0907V40.5648H92.1966V42.4741H94.3472L94.2485 43.0843H91.4863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1567 43.0843L96.2232 38.7539V43.0843H95.5918V37.6123H96.3218L98.2554 41.9426V37.6123H98.8867V43.0843H98.1567Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.51 43.0843L99.9707 37.6123H100.74L101.885 42.1592L103.049 37.6123H103.779L102.24 43.0843H101.51Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.863 43.0843V37.6123H105.554V43.0843H104.863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.695 43.0871L108.768 40.7841C108.669 40.8038 108.551 40.8235 108.393 40.8235H107.86V43.1067H107.17V37.6348H108.413C108.985 37.6348 109.439 37.7725 109.735 38.0284C110.031 38.2843 110.189 38.678 110.189 39.1701C110.189 39.485 110.129 39.7803 109.991 40.0165C109.853 40.2527 109.656 40.4495 109.419 40.5873L110.445 43.0871H109.695ZM108.354 40.2133C108.748 40.2133 109.044 40.1346 109.222 39.9771C109.399 39.8196 109.498 39.5441 109.498 39.1898C109.498 38.8551 109.399 38.6189 109.222 38.4615C109.044 38.304 108.748 38.2253 108.354 38.2253H107.86V40.233H108.354V40.2133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.385 43.227C112.734 43.227 112.26 42.9908 111.925 42.4987C111.589 42.0067 111.432 41.2981 111.432 40.3533C111.432 39.4085 111.609 38.6999 111.945 38.2078C112.28 37.7157 112.773 37.4795 113.424 37.4795C114.075 37.4795 114.549 37.7157 114.884 38.2078C115.22 38.6999 115.378 39.4085 115.378 40.3336C115.378 41.2784 115.22 41.987 114.884 42.4791C114.529 42.9908 114.036 43.227 113.385 43.227ZM113.405 42.6168C113.839 42.6168 114.135 42.4397 114.352 42.0657C114.549 41.6917 114.648 41.1209 114.648 40.3533C114.648 39.5856 114.549 39.0148 114.352 38.6408C114.154 38.2668 113.839 38.0897 113.405 38.0897C112.971 38.0897 112.675 38.2668 112.477 38.6408C112.28 39.0148 112.181 39.5856 112.181 40.3533C112.181 41.1209 112.28 41.6917 112.477 42.0657C112.675 42.4397 112.99 42.6168 113.405 42.6168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.346 43.0843L117.413 38.7539V43.0843H116.781V37.6123H117.511L119.445 41.9426V37.6123H120.076V43.0843H119.346Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.42 43.0843V38.8327L124.138 43.0843H123.566L122.303 38.8524V43.0843H121.691V37.6123H122.56L123.881 42.1395L125.203 37.6123H126.032V43.0843H125.42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.67 43.0843V37.6123H130.393V38.2225H128.38V39.9546H130.274V40.5648H128.38V42.4741H130.531L130.432 43.0843H127.67Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.34 43.0843L132.407 38.7539V43.0843H131.775V37.6123H132.505L134.439 41.9426V37.6123H135.07V43.0843H134.34Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.537 43.0843V38.2225H136.195V37.6123H139.569V38.2225H138.228V43.0843H137.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.14 43.0843L142.726 41.5883H140.99L140.575 43.0843H139.885L141.503 37.6123H142.233L143.851 43.0843H143.14ZM141.858 38.38L141.147 40.9978H142.568L141.858 38.38Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.955 43.0843V37.6123H145.646V42.4741H147.717L147.619 43.0843H144.955Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.346 43.0843V38.8327L153.064 43.0843H152.492L151.229 38.8524V43.0843H150.617V37.6123H151.485L152.807 42.1395L154.129 37.6123H154.958V43.0843H154.346Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.33 43.227C157.679 43.227 157.206 42.9908 156.87 42.4987C156.535 42.0067 156.377 41.2981 156.377 40.3533C156.377 39.4085 156.555 38.6999 156.89 38.2078C157.225 37.7157 157.719 37.4795 158.37 37.4795C159.021 37.4795 159.494 37.7157 159.83 38.2078C160.165 38.6999 160.323 39.4085 160.323 40.3336C160.323 41.2784 160.145 41.987 159.81 42.4791C159.455 42.9908 158.962 43.227 158.33 43.227ZM158.33 42.6168C158.764 42.6168 159.06 42.4397 159.258 42.0657C159.455 41.6917 159.554 41.1209 159.554 40.3533C159.554 39.5856 159.455 39.0148 159.258 38.6408C159.06 38.2668 158.745 38.0897 158.33 38.0897C157.896 38.0897 157.6 38.2668 157.403 38.6408C157.206 39.0148 157.107 39.5856 157.107 40.3533C157.107 41.1209 157.206 41.6917 157.403 42.0657C157.6 42.4397 157.916 42.6168 158.33 42.6168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.291 43.0843L162.358 38.7539V43.0843H161.727V37.6123H162.457L164.39 41.9426V37.6123H165.021V43.0843H164.291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.619 43.0843V37.6123H167.31V43.0843H166.619Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.795 43.0843V38.2225H168.453V37.6123H171.827V38.2225H170.485V43.0843H169.795Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.492 43.227C173.841 43.227 173.368 42.9908 173.032 42.4987C172.697 42.0067 172.539 41.2981 172.539 40.3533C172.539 39.4085 172.717 38.6999 173.052 38.2078C173.387 37.7157 173.881 37.4795 174.532 37.4795C175.183 37.4795 175.656 37.7157 175.992 38.2078C176.327 38.6999 176.485 39.4085 176.485 40.3336C176.485 41.2784 176.308 41.987 175.972 42.4791C175.637 42.9908 175.143 43.227 174.492 43.227ZM174.512 42.6168C174.946 42.6168 175.242 42.4397 175.439 42.0657C175.637 41.6917 175.735 41.1209 175.735 40.3533C175.735 39.5856 175.637 39.0148 175.439 38.6408C175.242 38.2668 174.926 38.0897 174.512 38.0897C174.078 38.0897 173.782 38.2668 173.585 38.6408C173.387 39.0148 173.289 39.5856 173.289 40.3533C173.289 41.1209 173.387 41.6917 173.585 42.0657C173.782 42.4397 174.098 42.6168 174.512 42.6168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.41 43.0871L179.483 40.7841C179.384 40.8038 179.266 40.8235 179.108 40.8235H178.556V43.1067H177.865V37.6348H179.108C179.68 37.6348 180.134 37.7725 180.43 38.0284C180.726 38.2843 180.884 38.678 180.884 39.1701C180.884 39.485 180.825 39.7803 180.687 40.0165C180.549 40.2527 180.351 40.4495 180.114 40.5873L181.14 43.0871H180.41ZM179.069 40.2133C179.463 40.2133 179.759 40.1346 179.937 39.9771C180.114 39.8196 180.213 39.5441 180.213 39.1898C180.213 38.8551 180.114 38.6189 179.937 38.4615C179.759 38.304 179.463 38.2253 179.069 38.2253H178.556V40.233H179.069V40.2133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.365 43.0843V37.6123H183.056V43.0843H182.365Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.237 43.0843L185.303 38.7539V43.0843H184.672V37.6123H185.402L187.335 41.9426V37.6123H187.967V43.0843H187.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.327 40.9033H191.34V40.2931H192.998V42.6551C192.741 42.8716 192.485 43.0094 192.208 43.1078C191.952 43.2062 191.656 43.2456 191.34 43.2456C190.689 43.2456 190.196 43.0094 189.86 42.5173C189.525 42.0252 189.367 41.3166 189.367 40.3718C189.367 39.427 189.525 38.7184 189.86 38.2263C190.196 37.7342 190.669 37.498 191.32 37.498C192.228 37.498 192.78 38.0098 192.978 39.053L192.287 39.1711C192.208 38.7971 192.09 38.5413 191.932 38.3641C191.774 38.187 191.557 38.1082 191.301 38.1082C190.886 38.1082 190.59 38.2854 190.393 38.6594C190.196 39.0137 190.097 39.5845 190.097 40.3718C190.097 41.1592 190.196 41.73 190.413 42.0843C190.63 42.4386 190.946 42.6354 191.399 42.6354C191.774 42.6354 192.09 42.537 192.327 42.3598V40.9033Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.9503 23.6503C14.3317 23.6503 14.6409 23.3419 14.6409 22.9614C14.6409 22.5809 14.3317 22.2725 13.9503 22.2725C13.5689 22.2725 13.2598 22.5809 13.2598 22.9614C13.2598 23.3419 13.5689 23.6503 13.9503 23.6503Z",
    fill: "url(#paint0_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.24229 23.5492C7.56919 23.5492 7.8342 23.2848 7.8342 22.9587C7.8342 22.6325 7.56919 22.3682 7.24229 22.3682C6.91539 22.3682 6.65039 22.6325 6.65039 22.9587C6.65039 23.2848 6.91539 23.5492 7.24229 23.5492Z",
    fill: "url(#paint1_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1052 4.30149C23.4103 4.30149 23.6576 4.05474 23.6576 3.75035C23.6576 3.44597 23.4103 3.19922 23.1052 3.19922C22.8001 3.19922 22.5527 3.44597 22.5527 3.75035C22.5527 4.05474 22.8001 4.30149 23.1052 4.30149Z",
    fill: "url(#paint2_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4802 4.49387C20.7853 4.49387 21.0326 4.24712 21.0326 3.94274C21.0326 3.63835 20.7853 3.3916 20.4802 3.3916C20.1751 3.3916 19.9277 3.63835 19.9277 3.94274C19.9277 4.24712 20.1751 4.49387 20.4802 4.49387Z",
    fill: "url(#paint3_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9157 5.03293C18.2208 5.03293 18.4682 4.78618 18.4682 4.4818C18.4682 4.17741 18.2208 3.93066 17.9157 3.93066C17.6106 3.93066 17.3633 4.17741 17.3633 4.4818C17.3633 4.78618 17.6106 5.03293 17.9157 5.03293Z",
    fill: "url(#paint4_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4489 5.89719C15.754 5.89719 16.0014 5.65044 16.0014 5.34606C16.0014 5.04167 15.754 4.79492 15.4489 4.79492C15.1438 4.79492 14.8965 5.04167 14.8965 5.34606C14.8965 5.65044 15.1438 5.89719 15.4489 5.89719Z",
    fill: "url(#paint5_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1228 7.08957C13.4279 7.08957 13.6752 6.84282 13.6752 6.53844C13.6752 6.23406 13.4279 5.9873 13.1228 5.9873C12.8176 5.9873 12.5703 6.23406 12.5703 6.53844C12.5703 6.84282 12.8176 7.08957 13.1228 7.08957Z",
    fill: "url(#paint6_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9704 8.60813C11.2755 8.60813 11.5229 8.36138 11.5229 8.05699C11.5229 7.75261 11.2755 7.50586 10.9704 7.50586C10.6653 7.50586 10.418 7.75261 10.418 8.05699C10.418 8.36138 10.6653 8.60813 10.9704 8.60813Z",
    fill: "url(#paint7_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.05635 10.3952C9.36146 10.3952 9.60879 10.1485 9.60879 9.8441C9.60879 9.53972 9.36146 9.29297 9.05635 9.29297C8.75124 9.29297 8.50391 9.53972 8.50391 9.8441C8.50391 10.1485 8.75124 10.3952 9.05635 10.3952Z",
    fill: "url(#paint8_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.39815 12.4304C7.70325 12.4304 7.95059 12.1836 7.95059 11.8793C7.95059 11.5749 7.70325 11.3281 7.39815 11.3281C7.09304 11.3281 6.8457 11.5749 6.8457 11.8793C6.8457 12.1836 7.09304 12.4304 7.39815 12.4304Z",
    fill: "url(#paint9_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.03877 14.6833C6.34388 14.6833 6.59122 14.4366 6.59122 14.1322C6.59122 13.8278 6.34388 13.5811 6.03877 13.5811C5.73367 13.5811 5.48633 13.8278 5.48633 14.1322C5.48633 14.4366 5.73367 14.6833 6.03877 14.6833Z",
    fill: "url(#paint10_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9919 17.0837C5.297 17.0837 5.54434 16.837 5.54434 16.5326C5.54434 16.2282 5.297 15.9814 4.9919 15.9814C4.68679 15.9814 4.43945 16.2282 4.43945 16.5326C4.43945 16.837 4.68679 17.0837 4.9919 17.0837Z",
    fill: "url(#paint11_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.28487 19.6032C4.58997 19.6032 4.83731 19.3565 4.83731 19.0521C4.83731 18.7477 4.58997 18.501 4.28487 18.501C3.97976 18.501 3.73242 18.7477 3.73242 19.0521C3.73242 19.3565 3.97976 19.6032 4.28487 19.6032Z",
    fill: "url(#paint12_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.92744 22.196C4.23255 22.196 4.47989 21.9493 4.47989 21.6449C4.47989 21.3405 4.23255 21.0938 3.92744 21.0938C3.62234 21.0938 3.375 21.3405 3.375 21.6449C3.375 21.9493 3.62234 22.196 3.92744 22.196Z",
    fill: "url(#paint13_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.92744 24.8103C4.23255 24.8103 4.47989 24.5635 4.47989 24.2591C4.47989 23.9548 4.23255 23.708 3.92744 23.708C3.62234 23.708 3.375 23.9548 3.375 24.2591C3.375 24.5635 3.62234 24.8103 3.92744 24.8103Z",
    fill: "url(#paint14_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.28096 27.407C4.58607 27.407 4.8334 27.1602 4.8334 26.8558C4.8334 26.5514 4.58607 26.3047 4.28096 26.3047C3.97585 26.3047 3.72852 26.5514 3.72852 26.8558C3.72852 27.1602 3.97585 27.407 4.28096 27.407Z",
    fill: "url(#paint15_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9919 29.9255C5.297 29.9255 5.54434 29.6788 5.54434 29.3744C5.54434 29.07 5.297 28.8232 4.9919 28.8232C4.68679 28.8232 4.43945 29.07 4.43945 29.3744C4.43945 29.6788 4.68679 29.9255 4.9919 29.9255Z",
    fill: "url(#paint16_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.03877 32.3269C6.34388 32.3269 6.59122 32.0801 6.59122 31.7757C6.59122 31.4714 6.34388 31.2246 6.03877 31.2246C5.73367 31.2246 5.48633 31.4714 5.48633 31.7757C5.48633 32.0801 5.73367 32.3269 6.03877 32.3269Z",
    fill: "url(#paint17_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.39815 34.5759C7.70325 34.5759 7.95059 34.3292 7.95059 34.0248C7.95059 33.7204 7.70325 33.4736 7.39815 33.4736C7.09304 33.4736 6.8457 33.7204 6.8457 34.0248C6.8457 34.3292 7.09304 34.5759 7.39815 34.5759Z",
    fill: "url(#paint18_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.05635 36.5925C9.36146 36.5925 9.60879 36.3457 9.60879 36.0414C9.60879 35.737 9.36146 35.4902 9.05635 35.4902C8.75124 35.4902 8.50391 35.737 8.50391 36.0414C8.50391 36.3457 8.75124 36.5925 9.05635 36.5925Z",
    fill: "url(#paint19_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9704 38.4021C11.2755 38.4021 11.5229 38.1553 11.5229 37.8509C11.5229 37.5466 11.2755 37.2998 10.9704 37.2998C10.6653 37.2998 10.418 37.5466 10.418 37.8509C10.418 38.1553 10.6653 38.4021 10.9704 38.4021Z",
    fill: "url(#paint20_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1228 39.9011C13.4279 39.9011 13.6752 39.6543 13.6752 39.35C13.6752 39.0456 13.4279 38.7988 13.1228 38.7988C12.8176 38.7988 12.5703 39.0456 12.5703 39.35C12.5703 39.6543 12.8176 39.9011 13.1228 39.9011Z",
    fill: "url(#paint21_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4489 41.113C15.754 41.113 16.0014 40.8663 16.0014 40.5619C16.0014 40.2575 15.754 40.0107 15.4489 40.0107C15.1438 40.0107 14.8965 40.2575 14.8965 40.5619C14.8965 40.8663 15.1438 41.113 15.4489 41.113Z",
    fill: "url(#paint22_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9157 41.9773C18.2208 41.9773 18.4682 41.7305 18.4682 41.4261C18.4682 41.1218 18.2208 40.875 17.9157 40.875C17.6106 40.875 17.3633 41.1218 17.3633 41.4261C17.3633 41.7305 17.6106 41.9773 17.9157 41.9773Z",
    fill: "url(#paint23_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5017 42.5349C20.8068 42.5349 21.0541 42.2881 21.0541 41.9838C21.0541 41.6794 20.8068 41.4326 20.5017 41.4326C20.1966 41.4326 19.9492 41.6794 19.9492 41.9838C19.9492 42.2881 20.1966 42.5349 20.5017 42.5349Z",
    fill: "url(#paint24_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1267 42.7077C23.4318 42.7077 23.6791 42.461 23.6791 42.1566C23.6791 41.8522 23.4318 41.6055 23.1267 41.6055C22.8216 41.6055 22.5742 41.8522 22.5742 42.1566C22.5742 42.461 22.8216 42.7077 23.1267 42.7077Z",
    fill: "url(#paint25_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7282 42.5349C26.0333 42.5349 26.2807 42.2881 26.2807 41.9838C26.2807 41.6794 26.0333 41.4326 25.7282 41.4326C25.4231 41.4326 25.1758 41.6794 25.1758 41.9838C25.1758 42.2881 25.4231 42.5349 25.7282 42.5349Z",
    fill: "url(#paint26_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3142 41.9773C28.6193 41.9773 28.8666 41.7305 28.8666 41.4261C28.8666 41.1218 28.6193 40.875 28.3142 40.875C28.0091 40.875 27.7617 41.1218 27.7617 41.4261C27.7617 41.7305 28.0091 41.9773 28.3142 41.9773Z",
    fill: "url(#paint27_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.779 41.113C31.0841 41.113 31.3315 40.8663 31.3315 40.5619C31.3315 40.2575 31.0841 40.0107 30.779 40.0107C30.4739 40.0107 30.2266 40.2575 30.2266 40.5619C30.2266 40.8663 30.4739 41.113 30.779 41.113Z",
    fill: "url(#paint28_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1091 39.9011C33.4142 39.9011 33.6615 39.6543 33.6615 39.35C33.6615 39.0456 33.4142 38.7988 33.1091 38.7988C32.804 38.7988 32.5566 39.0456 32.5566 39.35C32.5566 39.6543 32.804 39.9011 33.1091 39.9011Z",
    fill: "url(#paint29_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2595 38.4021C35.5646 38.4021 35.8119 38.1553 35.8119 37.8509C35.8119 37.5466 35.5646 37.2998 35.2595 37.2998C34.9544 37.2998 34.707 37.5466 34.707 37.8509C34.707 38.1553 34.9544 38.4021 35.2595 38.4021Z",
    fill: "url(#paint30_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1735 36.5925C37.4786 36.5925 37.726 36.3457 37.726 36.0414C37.726 35.737 37.4786 35.4902 37.1735 35.4902C36.8684 35.4902 36.6211 35.737 36.6211 36.0414C36.6211 36.3457 36.8684 36.5925 37.1735 36.5925Z",
    fill: "url(#paint31_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8278 34.5759C39.1329 34.5759 39.3803 34.3292 39.3803 34.0248C39.3803 33.7204 39.1329 33.4736 38.8278 33.4736C38.5227 33.4736 38.2754 33.7204 38.2754 34.0248C38.2754 34.3292 38.5227 34.5759 38.8278 34.5759Z",
    fill: "url(#paint32_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1911 32.3269C40.4962 32.3269 40.7436 32.0801 40.7436 31.7757C40.7436 31.4714 40.4962 31.2246 40.1911 31.2246C39.886 31.2246 39.6387 31.4714 39.6387 31.7757C39.6387 32.0801 39.886 32.3269 40.1911 32.3269Z",
    fill: "url(#paint33_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.238 29.9255C41.5431 29.9255 41.7904 29.6788 41.7904 29.3744C41.7904 29.07 41.5431 28.8232 41.238 28.8232C40.9329 28.8232 40.6855 29.07 40.6855 29.3744C40.6855 29.6788 40.9329 29.9255 41.238 29.9255Z",
    fill: "url(#paint34_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9489 27.407C42.254 27.407 42.5014 27.1602 42.5014 26.8558C42.5014 26.5514 42.254 26.3047 41.9489 26.3047C41.6438 26.3047 41.3965 26.5514 41.3965 26.8558C41.3965 27.1602 41.6438 27.407 41.9489 27.407Z",
    fill: "url(#paint35_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3024 24.8103C42.6075 24.8103 42.8549 24.5635 42.8549 24.2591C42.8549 23.9548 42.6075 23.708 42.3024 23.708C41.9973 23.708 41.75 23.9548 41.75 24.2591C41.75 24.5635 41.9973 24.8103 42.3024 24.8103Z",
    fill: "url(#paint36_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3024 22.196C42.6075 22.196 42.8549 21.9493 42.8549 21.6449C42.8549 21.3405 42.6075 21.0938 42.3024 21.0938C41.9973 21.0938 41.75 21.3405 41.75 21.6449C41.75 21.9493 41.9973 22.196 42.3024 22.196Z",
    fill: "url(#paint37_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9489 19.6032C42.254 19.6032 42.5014 19.3565 42.5014 19.0521C42.5014 18.7477 42.254 18.501 41.9489 18.501C41.6438 18.501 41.3965 18.7477 41.3965 19.0521C41.3965 19.3565 41.6438 19.6032 41.9489 19.6032Z",
    fill: "url(#paint38_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.238 17.0837C41.5431 17.0837 41.7904 16.837 41.7904 16.5326C41.7904 16.2282 41.5431 15.9814 41.238 15.9814C40.9329 15.9814 40.6855 16.2282 40.6855 16.5326C40.6855 16.837 40.9329 17.0837 41.238 17.0837Z",
    fill: "url(#paint39_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1911 14.6833C40.4962 14.6833 40.7436 14.4366 40.7436 14.1322C40.7436 13.8278 40.4962 13.5811 40.1911 13.5811C39.886 13.5811 39.6387 13.8278 39.6387 14.1322C39.6387 14.4366 39.886 14.6833 40.1911 14.6833Z",
    fill: "url(#paint40_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8278 12.4304C39.1329 12.4304 39.3803 12.1836 39.3803 11.8793C39.3803 11.5749 39.1329 11.3281 38.8278 11.3281C38.5227 11.3281 38.2754 11.5749 38.2754 11.8793C38.2754 12.1836 38.5227 12.4304 38.8278 12.4304Z",
    fill: "url(#paint41_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1735 10.3952C37.4786 10.3952 37.726 10.1485 37.726 9.8441C37.726 9.53972 37.4786 9.29297 37.1735 9.29297C36.8684 9.29297 36.6211 9.53972 36.6211 9.8441C36.6211 10.1485 36.8684 10.3952 37.1735 10.3952Z",
    fill: "url(#paint42_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2595 8.60813C35.5646 8.60813 35.8119 8.36138 35.8119 8.05699C35.8119 7.75261 35.5646 7.50586 35.2595 7.50586C34.9544 7.50586 34.707 7.75261 34.707 8.05699C34.707 8.36138 34.9544 8.60813 35.2595 8.60813Z",
    fill: "url(#paint43_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1091 7.08957C33.4142 7.08957 33.6615 6.84282 33.6615 6.53844C33.6615 6.23406 33.4142 5.9873 33.1091 5.9873C32.804 5.9873 32.5566 6.23406 32.5566 6.53844C32.5566 6.84282 32.804 7.08957 33.1091 7.08957Z",
    fill: "url(#paint44_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.779 5.89719C31.0841 5.89719 31.3315 5.65044 31.3315 5.34606C31.3315 5.04167 31.0841 4.79492 30.779 4.79492C30.4739 4.79492 30.2266 5.04167 30.2266 5.34606C30.2266 5.65044 30.4739 5.89719 30.779 5.89719Z",
    fill: "url(#paint45_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2946 5.03293C28.5997 5.03293 28.8471 4.78618 28.8471 4.4818C28.8471 4.17741 28.5997 3.93066 28.2946 3.93066C27.9895 3.93066 27.7422 4.17741 27.7422 4.4818C27.7422 4.78618 27.9895 5.03293 28.2946 5.03293Z",
    fill: "url(#paint46_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7282 4.47531C26.0333 4.47531 26.2807 4.22856 26.2807 3.92418C26.2807 3.6198 26.0333 3.37305 25.7282 3.37305C25.4231 3.37305 25.1758 3.6198 25.1758 3.92418C25.1758 4.22856 25.4231 4.47531 25.7282 4.47531Z",
    fill: "url(#paint47_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.493253 23.448C0.765669 23.448 0.986506 23.2277 0.986506 22.956C0.986506 22.6842 0.765669 22.4639 0.493253 22.4639C0.220837 22.4639 0 22.6842 0 22.956C0 23.2277 0.220837 23.448 0.493253 23.448Z",
    fill: "url(#paint48_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.631925 26.0818C0.904341 26.0818 1.12518 25.8615 1.12518 25.5897C1.12518 25.318 0.904341 25.0977 0.631925 25.0977C0.359509 25.0977 0.138672 25.318 0.138672 25.5897C0.138672 25.8615 0.359509 26.0818 0.631925 26.0818Z",
    fill: "url(#paint49_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.0831 28.659C1.35551 28.659 1.57635 28.4387 1.57635 28.1669C1.57635 27.8951 1.35551 27.6748 1.0831 27.6748C0.810681 27.6748 0.589844 27.8951 0.589844 28.1669C0.589844 28.4387 0.810681 28.659 1.0831 28.659Z",
    fill: "url(#paint50_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.85263 31.1785C2.12504 31.1785 2.34588 30.9582 2.34588 30.6864C2.34588 30.4146 2.12504 30.1943 1.85263 30.1943C1.58021 30.1943 1.35938 30.4146 1.35938 30.6864C1.35938 30.9582 1.58021 31.1785 1.85263 31.1785Z",
    fill: "url(#paint51_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.88192 33.5789C3.15434 33.5789 3.37518 33.3586 3.37518 33.0868C3.37518 32.815 3.15434 32.5947 2.88192 32.5947C2.60951 32.5947 2.38867 32.815 2.38867 33.0868C2.38867 33.3586 2.60951 33.5789 2.88192 33.5789Z",
    fill: "url(#paint52_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.20028 35.8465C4.4727 35.8465 4.69354 35.6262 4.69354 35.3544C4.69354 35.0826 4.4727 34.8623 4.20028 34.8623C3.92787 34.8623 3.70703 35.0826 3.70703 35.3544C3.70703 35.6262 3.92787 35.8465 4.20028 35.8465Z",
    fill: "url(#paint53_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.78036 37.9441C6.05278 37.9441 6.27362 37.7238 6.27362 37.452C6.27362 37.1803 6.05278 36.96 5.78036 36.96C5.50795 36.96 5.28711 37.1803 5.28711 37.452C5.28711 37.7238 5.50795 37.9441 5.78036 37.9441Z",
    fill: "url(#paint54_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.57724 39.8465C7.84965 39.8465 8.07049 39.6262 8.07049 39.3544C8.07049 39.0826 7.84965 38.8623 7.57724 38.8623C7.30482 38.8623 7.08398 39.0826 7.08398 39.3544C7.08398 39.6262 7.30482 39.8465 7.57724 39.8465Z",
    fill: "url(#paint55_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.58896 41.5564C9.86137 41.5564 10.0822 41.3361 10.0822 41.0643C10.0822 40.7926 9.86137 40.5723 9.58896 40.5723C9.31654 40.5723 9.0957 40.7926 9.0957 41.0643C9.0957 41.3361 9.31654 41.5564 9.58896 41.5564Z",
    fill: "url(#paint56_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7979 42.9783C12.0704 42.9783 12.2912 42.758 12.2912 42.4862C12.2912 42.2145 12.0704 41.9941 11.7979 41.9941C11.5255 41.9941 11.3047 42.2145 11.3047 42.4862C11.3047 42.758 11.5255 42.9783 11.7979 42.9783Z",
    fill: "url(#paint57_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1475 44.1717C14.42 44.1717 14.6408 43.9514 14.6408 43.6796C14.6408 43.4078 14.42 43.1875 14.1475 43.1875C13.8751 43.1875 13.6543 43.4078 13.6543 43.6796C13.6543 43.9514 13.8751 44.1717 14.1475 44.1717Z",
    fill: "url(#paint58_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6124 45.076C16.8848 45.076 17.1056 44.8557 17.1056 44.5839C17.1056 44.3121 16.8848 44.0918 16.6124 44.0918C16.34 44.0918 16.1191 44.3121 16.1191 44.5839C16.1191 44.8557 16.34 45.076 16.6124 45.076Z",
    fill: "url(#paint59_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1768 45.6707C19.4493 45.6707 19.6701 45.4504 19.6701 45.1786C19.6701 44.9068 19.4493 44.6865 19.1768 44.6865C18.9044 44.6865 18.6836 44.9068 18.6836 45.1786C18.6836 45.4504 18.9044 45.6707 19.1768 45.6707Z",
    fill: "url(#paint60_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7804 45.9773C22.0528 45.9773 22.2736 45.757 22.2736 45.4852C22.2736 45.2135 22.0528 44.9932 21.7804 44.9932C21.5079 44.9932 21.2871 45.2135 21.2871 45.4852C21.2871 45.757 21.5079 45.9773 21.7804 45.9773Z",
    fill: "url(#paint61_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4054 45.9773C24.6778 45.9773 24.8986 45.757 24.8986 45.4852C24.8986 45.2135 24.6778 44.9932 24.4054 44.9932C24.1329 44.9932 23.9121 45.2135 23.9121 45.4852C23.9121 45.757 24.1329 45.9773 24.4054 45.9773Z",
    fill: "url(#paint62_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0304 45.6707C27.3028 45.6707 27.5236 45.4504 27.5236 45.1786C27.5236 44.9068 27.3028 44.6865 27.0304 44.6865C26.7579 44.6865 26.5371 44.9068 26.5371 45.1786C26.5371 45.4504 26.7579 45.6707 27.0304 45.6707Z",
    fill: "url(#paint63_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5753 45.076C29.8477 45.076 30.0685 44.8557 30.0685 44.5839C30.0685 44.3121 29.8477 44.0918 29.5753 44.0918C29.3029 44.0918 29.082 44.3121 29.082 44.5839C29.082 44.8557 29.3029 45.076 29.5753 45.076Z",
    fill: "url(#paint64_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0616 44.1717C32.334 44.1717 32.5549 43.9514 32.5549 43.6796C32.5549 43.4078 32.334 43.1875 32.0616 43.1875C31.7892 43.1875 31.5684 43.4078 31.5684 43.6796C31.5684 43.9514 31.7892 44.1717 32.0616 44.1717Z",
    fill: "url(#paint65_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4093 42.9783C34.6817 42.9783 34.9025 42.758 34.9025 42.4862C34.9025 42.2145 34.6817 41.9941 34.4093 41.9941C34.1369 41.9941 33.916 42.2145 33.916 42.4862C33.916 42.758 34.1369 42.9783 34.4093 42.9783Z",
    fill: "url(#paint66_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6007 41.5564C36.8731 41.5564 37.0939 41.3361 37.0939 41.0643C37.0939 40.7926 36.8731 40.5723 36.6007 40.5723C36.3283 40.5723 36.1074 40.7926 36.1074 41.0643C36.1074 41.3361 36.3283 41.5564 36.6007 41.5564Z",
    fill: "url(#paint67_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6124 39.8465C38.8848 39.8465 39.1056 39.6262 39.1056 39.3544C39.1056 39.0826 38.8848 38.8623 38.6124 38.8623C38.34 38.8623 38.1191 39.0826 38.1191 39.3544C38.1191 39.6262 38.34 39.8465 38.6124 39.8465Z",
    fill: "url(#paint68_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4249 37.9441C40.6973 37.9441 40.9181 37.7238 40.9181 37.452C40.9181 37.1803 40.6973 36.96 40.4249 36.96C40.1525 36.96 39.9316 37.1803 39.9316 37.452C39.9316 37.7238 40.1525 37.9441 40.4249 37.9441Z",
    fill: "url(#paint69_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9854 35.8465C42.2579 35.8465 42.4787 35.6262 42.4787 35.3544C42.4787 35.0826 42.2579 34.8623 41.9854 34.8623C41.713 34.8623 41.4922 35.0826 41.4922 35.3544C41.4922 35.6262 41.713 35.8465 41.9854 35.8465Z",
    fill: "url(#paint70_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3058 33.5789C43.5782 33.5789 43.799 33.3586 43.799 33.0868C43.799 32.815 43.5782 32.5947 43.3058 32.5947C43.0333 32.5947 42.8125 32.815 42.8125 33.0868C42.8125 33.3586 43.0333 33.5789 43.3058 33.5789Z",
    fill: "url(#paint71_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3526 31.1785C44.625 31.1785 44.8459 30.9582 44.8459 30.6864C44.8459 30.4146 44.625 30.1943 44.3526 30.1943C44.0802 30.1943 43.8594 30.4146 43.8594 30.6864C43.8594 30.9582 44.0802 31.1785 44.3526 31.1785Z",
    fill: "url(#paint72_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1026 28.659C45.375 28.659 45.5959 28.4387 45.5959 28.1669C45.5959 27.8951 45.375 27.6748 45.1026 27.6748C44.8302 27.6748 44.6094 27.8951 44.6094 28.1669C44.6094 28.4387 44.8302 28.659 45.1026 28.659Z",
    fill: "url(#paint73_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5558 26.0818C45.8282 26.0818 46.049 25.8615 46.049 25.5897C46.049 25.318 45.8282 25.0977 45.5558 25.0977C45.2833 25.0977 45.0625 25.318 45.0625 25.5897C45.0625 25.8615 45.2833 26.0818 45.5558 26.0818Z",
    fill: "url(#paint74_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7159 23.448C45.9883 23.448 46.2092 23.2277 46.2092 22.956C46.2092 22.6842 45.9883 22.4639 45.7159 22.4639C45.4435 22.4639 45.2227 22.6842 45.2227 22.956C45.2227 23.2277 45.4435 23.448 45.7159 23.448Z",
    fill: "url(#paint75_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5558 20.8367C45.8282 20.8367 46.049 20.6164 46.049 20.3446C46.049 20.0729 45.8282 19.8525 45.5558 19.8525C45.2833 19.8525 45.0625 20.0729 45.0625 20.3446C45.0625 20.6164 45.2833 20.8367 45.5558 20.8367Z",
    fill: "url(#paint76_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1026 18.241C45.375 18.241 45.5959 18.0207 45.5959 17.7489C45.5959 17.4771 45.375 17.2568 45.1026 17.2568C44.8302 17.2568 44.6094 17.4771 44.6094 17.7489C44.6094 18.0207 44.8302 18.241 45.1026 18.241Z",
    fill: "url(#paint77_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3526 15.7439C44.625 15.7439 44.8459 15.5236 44.8459 15.2518C44.8459 14.9801 44.625 14.7598 44.3526 14.7598C44.0802 14.7598 43.8594 14.9801 43.8594 15.2518C43.8594 15.5236 44.0802 15.7439 44.3526 15.7439Z",
    fill: "url(#paint78_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3058 13.3211C43.5782 13.3211 43.799 13.1008 43.799 12.829C43.799 12.5572 43.5782 12.3369 43.3058 12.3369C43.0333 12.3369 42.8125 12.5572 42.8125 12.829C42.8125 13.1008 43.0333 13.3211 43.3058 13.3211Z",
    fill: "url(#paint79_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9854 11.0535C42.2579 11.0535 42.4787 10.8332 42.4787 10.5614C42.4787 10.2896 42.2579 10.0693 41.9854 10.0693C41.713 10.0693 41.4922 10.2896 41.4922 10.5614C41.4922 10.8332 41.713 11.0535 41.9854 11.0535Z",
    fill: "url(#paint80_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4249 8.95585C40.6973 8.95585 40.9181 8.73553 40.9181 8.46376C40.9181 8.19199 40.6973 7.97168 40.4249 7.97168C40.1525 7.97168 39.9316 8.19199 39.9316 8.46376C39.9316 8.73553 40.1525 8.95585 40.4249 8.95585Z",
    fill: "url(#paint81_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6124 7.03495C38.8848 7.03495 39.1056 6.81464 39.1056 6.54287C39.1056 6.27109 38.8848 6.05078 38.6124 6.05078C38.34 6.05078 38.1191 6.27109 38.1191 6.54287C38.1191 6.81464 38.34 7.03495 38.6124 7.03495Z",
    fill: "url(#paint82_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6007 5.34354C36.8731 5.34354 37.0939 5.12323 37.0939 4.85146C37.0939 4.57969 36.8731 4.35938 36.6007 4.35938C36.3283 4.35938 36.1074 4.57969 36.1074 4.85146C36.1074 5.12323 36.3283 5.34354 36.6007 5.34354Z",
    fill: "url(#paint83_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4093 3.92167C34.6817 3.92167 34.9025 3.70135 34.9025 3.42958C34.9025 3.15781 34.6817 2.9375 34.4093 2.9375C34.1369 2.9375 33.916 3.15781 33.916 3.42958C33.916 3.70135 34.1369 3.92167 34.4093 3.92167Z",
    fill: "url(#paint84_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0616 2.72831C32.334 2.72831 32.5549 2.50799 32.5549 2.23622C32.5549 1.96445 32.334 1.74414 32.0616 1.74414C31.7892 1.74414 31.5684 1.96445 31.5684 2.23622C31.5684 2.50799 31.7892 2.72831 32.0616 2.72831Z",
    fill: "url(#paint85_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5753 1.8455C29.8477 1.8455 30.0685 1.62518 30.0685 1.35341C30.0685 1.08164 29.8477 0.861328 29.5753 0.861328C29.3029 0.861328 29.082 1.08164 29.082 1.35341C29.082 1.62518 29.3029 1.8455 29.5753 1.8455Z",
    fill: "url(#paint86_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0304 1.22928C27.3028 1.22928 27.5236 1.00897 27.5236 0.737201C27.5236 0.465431 27.3028 0.245117 27.0304 0.245117C26.7579 0.245117 26.5371 0.465431 26.5371 0.737201C26.5371 1.00897 26.7579 1.22928 27.0304 1.22928Z",
    fill: "url(#paint87_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4054 0.941199C24.6778 0.941199 24.8986 0.720886 24.8986 0.449115C24.8986 0.177345 24.6778 -0.0429688 24.4054 -0.0429688C24.1329 -0.0429688 23.9121 0.177345 23.9121 0.449115C23.9121 0.720886 24.1329 0.941199 24.4054 0.941199Z",
    fill: "url(#paint88_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7804 0.941199C22.0528 0.941199 22.2736 0.720886 22.2736 0.449115C22.2736 0.177345 22.0528 -0.0429688 21.7804 -0.0429688C21.5079 -0.0429688 21.2871 0.177345 21.2871 0.449115C21.2871 0.720886 21.5079 0.941199 21.7804 0.941199Z",
    fill: "url(#paint89_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1768 1.22928C19.4493 1.22928 19.6701 1.00897 19.6701 0.737201C19.6701 0.465431 19.4493 0.245117 19.1768 0.245117C18.9044 0.245117 18.6836 0.465431 18.6836 0.737201C18.6836 1.00897 18.9044 1.22928 19.1768 1.22928Z",
    fill: "url(#paint90_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6124 1.8455C16.8848 1.8455 17.1056 1.62518 17.1056 1.35341C17.1056 1.08164 16.8848 0.861328 16.6124 0.861328C16.34 0.861328 16.1191 1.08164 16.1191 1.35341C16.1191 1.62518 16.34 1.8455 16.6124 1.8455Z",
    fill: "url(#paint91_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1475 2.72831C14.42 2.72831 14.6408 2.50799 14.6408 2.23622C14.6408 1.96445 14.42 1.74414 14.1475 1.74414C13.8751 1.74414 13.6543 1.96445 13.6543 2.23622C13.6543 2.50799 13.8751 2.72831 14.1475 2.72831Z",
    fill: "url(#paint92_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7979 3.92167C12.0704 3.92167 12.2912 3.70135 12.2912 3.42958C12.2912 3.15781 12.0704 2.9375 11.7979 2.9375C11.5255 2.9375 11.3047 3.15781 11.3047 3.42958C11.3047 3.70135 11.5255 3.92167 11.7979 3.92167Z",
    fill: "url(#paint93_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.58896 5.34354C9.86137 5.34354 10.0822 5.12323 10.0822 4.85146C10.0822 4.57969 9.86137 4.35938 9.58896 4.35938C9.31654 4.35938 9.0957 4.57969 9.0957 4.85146C9.0957 5.12323 9.31654 5.34354 9.58896 5.34354Z",
    fill: "url(#paint94_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.57724 7.03495C7.84965 7.03495 8.07049 6.81464 8.07049 6.54287C8.07049 6.27109 7.84965 6.05078 7.57724 6.05078C7.30482 6.05078 7.08398 6.27109 7.08398 6.54287C7.08398 6.81464 7.30482 7.03495 7.57724 7.03495Z",
    fill: "url(#paint95_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.78036 8.95585C6.05278 8.95585 6.27362 8.73553 6.27362 8.46376C6.27362 8.19199 6.05278 7.97168 5.78036 7.97168C5.50795 7.97168 5.28711 8.19199 5.28711 8.46376C5.28711 8.73553 5.50795 8.95585 5.78036 8.95585Z",
    fill: "url(#paint96_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.20028 11.0535C4.4727 11.0535 4.69354 10.8332 4.69354 10.5614C4.69354 10.2896 4.4727 10.0693 4.20028 10.0693C3.92787 10.0693 3.70703 10.2896 3.70703 10.5614C3.70703 10.8332 3.92787 11.0535 4.20028 11.0535Z",
    fill: "url(#paint97_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8995 13.3211C3.17192 13.3211 3.39276 13.1008 3.39276 12.829C3.39276 12.5572 3.17192 12.3369 2.8995 12.3369C2.62709 12.3369 2.40625 12.5572 2.40625 12.829C2.40625 13.1008 2.62709 13.3211 2.8995 13.3211Z",
    fill: "url(#paint98_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.85263 15.7439C2.12504 15.7439 2.34588 15.5236 2.34588 15.2518C2.34588 14.9801 2.12504 14.7598 1.85263 14.7598C1.58021 14.7598 1.35938 14.9801 1.35938 15.2518C1.35938 15.5236 1.58021 15.7439 1.85263 15.7439Z",
    fill: "url(#paint99_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.0831 18.241C1.35551 18.241 1.57635 18.0207 1.57635 17.7489C1.57635 17.4771 1.35551 17.2568 1.0831 17.2568C0.810681 17.2568 0.589844 17.4771 0.589844 17.7489C0.589844 18.0207 0.810681 18.241 1.0831 18.241Z",
    fill: "url(#paint100_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.631925 20.8367C0.904341 20.8367 1.12518 20.6164 1.12518 20.3446C1.12518 20.0729 0.904341 19.8525 0.631925 19.8525C0.359509 19.8525 0.138672 20.0729 0.138672 20.3446C0.138672 20.6164 0.359509 20.8367 0.631925 20.8367Z",
    fill: "url(#paint101_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.45714 26.1644C7.78404 26.1644 8.04904 25.9 8.04904 25.5739C8.04904 25.2478 7.78404 24.9834 7.45714 24.9834C7.13024 24.9834 6.86523 25.2478 6.86523 25.5739C6.86523 25.9 7.13024 26.1644 7.45714 26.1644Z",
    fill: "url(#paint102_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.10948 28.7015C8.43638 28.7015 8.70139 28.4371 8.70139 28.111C8.70139 27.7849 8.43638 27.5205 8.10948 27.5205C7.78258 27.5205 7.51758 27.7849 7.51758 28.111C7.51758 28.4371 7.78258 28.7015 8.10948 28.7015Z",
    fill: "url(#paint103_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.15636 31.0873C9.48326 31.0873 9.74826 30.8229 9.74826 30.4968C9.74826 30.1706 9.48326 29.9062 9.15636 29.9062C8.82946 29.9062 8.56445 30.1706 8.56445 30.4968C8.56445 30.8229 8.82946 31.0873 9.15636 31.0873Z",
    fill: "url(#paint104_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5958 33.2581C10.9227 33.2581 11.1877 32.9938 11.1877 32.6676C11.1877 32.3415 10.9227 32.0771 10.5958 32.0771C10.2689 32.0771 10.0039 32.3415 10.0039 32.6676C10.0039 32.9938 10.2689 33.2581 10.5958 33.2581Z",
    fill: "url(#paint105_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3712 35.1976C12.6981 35.1976 12.9631 34.9332 12.9631 34.6071C12.9631 34.281 12.6981 34.0166 12.3712 34.0166C12.0443 34.0166 11.7793 34.281 11.7793 34.6071C11.7793 34.9332 12.0443 35.1976 12.3712 35.1976Z",
    fill: "url(#paint106_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4239 36.7748C14.7508 36.7748 15.0158 36.5104 15.0158 36.1843C15.0158 35.8581 14.7508 35.5938 14.4239 35.5938C14.097 35.5938 13.832 35.8581 13.832 36.1843C13.832 36.5104 14.097 36.7748 14.4239 36.7748Z",
    fill: "url(#paint107_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7325 38.0453C17.0594 38.0453 17.3244 37.7809 17.3244 37.4548C17.3244 37.1286 17.0594 36.8643 16.7325 36.8643C16.4056 36.8643 16.1406 37.1286 16.1406 37.4548C16.1406 37.7809 16.4056 38.0453 16.7325 38.0453Z",
    fill: "url(#paint108_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2189 38.891C19.5458 38.891 19.8108 38.6266 19.8108 38.3005C19.8108 37.9743 19.5458 37.71 19.2189 37.71C18.892 37.71 18.627 37.9743 18.627 38.3005C18.627 38.6266 18.892 38.891 19.2189 38.891Z",
    fill: "url(#paint109_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8028 39.3304C22.1297 39.3304 22.3947 39.066 22.3947 38.7399C22.3947 38.4138 22.1297 38.1494 21.8028 38.1494C21.4759 38.1494 21.2109 38.4138 21.2109 38.7399C21.2109 39.066 21.4759 39.3304 21.8028 39.3304Z",
    fill: "url(#paint110_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4064 39.3304C24.7333 39.3304 24.9983 39.066 24.9983 38.7399C24.9983 38.4138 24.7333 38.1494 24.4064 38.1494C24.0795 38.1494 23.8145 38.4138 23.8145 38.7399C23.8145 39.066 24.0795 39.3304 24.4064 39.3304Z",
    fill: "url(#paint111_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9903 38.891C27.3172 38.891 27.5822 38.6266 27.5822 38.3005C27.5822 37.9743 27.3172 37.71 26.9903 37.71C26.6634 37.71 26.3984 37.9743 26.3984 38.3005C26.3984 38.6266 26.6634 38.891 26.9903 38.891Z",
    fill: "url(#paint112_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4767 38.0453C29.8036 38.0453 30.0686 37.7809 30.0686 37.4548C30.0686 37.1286 29.8036 36.8643 29.4767 36.8643C29.1498 36.8643 28.8848 37.1286 28.8848 37.4548C28.8848 37.7809 29.1498 38.0453 29.4767 38.0453Z",
    fill: "url(#paint113_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7853 36.7748C32.1122 36.7748 32.3772 36.5104 32.3772 36.1843C32.3772 35.8581 32.1122 35.5938 31.7853 35.5938C31.4584 35.5938 31.1934 35.8581 31.1934 36.1843C31.1934 36.5104 31.4584 36.7748 31.7853 36.7748Z",
    fill: "url(#paint114_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.838 35.1976C34.1649 35.1976 34.4299 34.9332 34.4299 34.6071C34.4299 34.281 34.1649 34.0166 33.838 34.0166C33.5111 34.0166 33.2461 34.281 33.2461 34.6071C33.2461 34.9332 33.5111 35.1976 33.838 35.1976Z",
    fill: "url(#paint115_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6134 33.2581C35.9403 33.2581 36.2053 32.9938 36.2053 32.6676C36.2053 32.3415 35.9403 32.0771 35.6134 32.0771C35.2865 32.0771 35.0215 32.3415 35.0215 32.6676C35.0215 32.9938 35.2865 33.2581 35.6134 33.2581Z",
    fill: "url(#paint116_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0528 31.0873C37.3797 31.0873 37.6447 30.8229 37.6447 30.4968C37.6447 30.1706 37.3797 29.9062 37.0528 29.9062C36.7259 29.9062 36.4609 30.1706 36.4609 30.4968C36.4609 30.8229 36.7259 31.0873 37.0528 31.0873Z",
    fill: "url(#paint117_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0997 28.683C38.4266 28.683 38.6916 28.4186 38.6916 28.0925C38.6916 27.7663 38.4266 27.502 38.0997 27.502C37.7728 27.502 37.5078 27.7663 37.5078 28.0925C37.5078 28.4186 37.7728 28.683 38.0997 28.683Z",
    fill: "url(#paint118_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7482 26.1644C39.0751 26.1644 39.3401 25.9 39.3401 25.5739C39.3401 25.2478 39.0751 24.9834 38.7482 24.9834C38.4213 24.9834 38.1562 25.2478 38.1562 25.5739C38.1562 25.9 38.4213 26.1644 38.7482 26.1644Z",
    fill: "url(#paint119_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9669 23.5306C39.2938 23.5306 39.5588 23.2662 39.5588 22.9401C39.5588 22.614 39.2938 22.3496 38.9669 22.3496C38.64 22.3496 38.375 22.614 38.375 22.9401C38.375 23.2662 38.64 23.5306 38.9669 23.5306Z",
    fill: "url(#paint120_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7482 20.9378C39.0751 20.9378 39.3401 20.6735 39.3401 20.3473C39.3401 20.0212 39.0751 19.7568 38.7482 19.7568C38.4213 19.7568 38.1562 20.0212 38.1562 20.3473C38.1562 20.6735 38.4213 20.9378 38.7482 20.9378Z",
    fill: "url(#paint121_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0997 18.4007C38.4266 18.4007 38.6916 18.1364 38.6916 17.8102C38.6916 17.4841 38.4266 17.2197 38.0997 17.2197C37.7728 17.2197 37.5078 17.4841 37.5078 17.8102C37.5078 18.1364 37.7728 18.4007 38.0997 18.4007Z",
    fill: "url(#paint122_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0528 16.015C37.3797 16.015 37.6447 15.7506 37.6447 15.4245C37.6447 15.0984 37.3797 14.834 37.0528 14.834C36.7259 14.834 36.4609 15.0984 36.4609 15.4245C36.4609 15.7506 36.7259 16.015 37.0528 16.015Z",
    fill: "url(#paint123_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6134 13.8246C35.9403 13.8246 36.2053 13.5602 36.2053 13.2341C36.2053 12.9079 35.9403 12.6436 35.6134 12.6436C35.2865 12.6436 35.0215 12.9079 35.0215 13.2341C35.0215 13.5602 35.2865 13.8246 35.6134 13.8246Z",
    fill: "url(#paint124_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.838 11.9037C34.1649 11.9037 34.4299 11.6393 34.4299 11.3132C34.4299 10.987 34.1649 10.7227 33.838 10.7227C33.5111 10.7227 33.2461 10.987 33.2461 11.3132C33.2461 11.6393 33.5111 11.9037 33.838 11.9037Z",
    fill: "url(#paint125_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7657 10.305C32.0926 10.305 32.3576 10.0406 32.3576 9.71452C32.3576 9.3884 32.0926 9.12402 31.7657 9.12402C31.4388 9.12402 31.1738 9.3884 31.1738 9.71452C31.1738 10.0406 31.4388 10.305 31.7657 10.305Z",
    fill: "url(#paint126_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4767 9.05698C29.8036 9.05698 30.0686 8.7926 30.0686 8.46648C30.0686 8.14035 29.8036 7.87598 29.4767 7.87598C29.1498 7.87598 28.8848 8.14035 28.8848 8.46648C28.8848 8.7926 29.1498 9.05698 29.4767 9.05698Z",
    fill: "url(#paint127_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9903 8.21127C27.3172 8.21127 27.5822 7.9469 27.5822 7.62077C27.5822 7.29465 27.3172 7.03027 26.9903 7.03027C26.6634 7.03027 26.3984 7.29465 26.3984 7.62077C26.3984 7.9469 26.6634 8.21127 26.9903 8.21127Z",
    fill: "url(#paint128_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4064 7.76792C24.7333 7.76792 24.9983 7.50354 24.9983 7.17741C24.9983 6.85129 24.7333 6.58691 24.4064 6.58691C24.0795 6.58691 23.8145 6.85129 23.8145 7.17741C23.8145 7.50354 24.0795 7.76792 24.4064 7.76792Z",
    fill: "url(#paint129_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7814 7.7894C22.1083 7.7894 22.3733 7.52502 22.3733 7.1989C22.3733 6.87277 22.1083 6.6084 21.7814 6.6084C21.4545 6.6084 21.1895 6.87277 21.1895 7.1989C21.1895 7.52502 21.4545 7.7894 21.7814 7.7894Z",
    fill: "url(#paint130_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1974 8.21127C19.5243 8.21127 19.7893 7.9469 19.7893 7.62077C19.7893 7.29465 19.5243 7.03027 19.1974 7.03027C18.8705 7.03027 18.6055 7.29465 18.6055 7.62077C18.6055 7.9469 18.8705 8.21127 19.1974 8.21127Z",
    fill: "url(#paint131_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7325 9.07553C17.0594 9.07553 17.3244 8.81116 17.3244 8.48503C17.3244 8.15891 17.0594 7.89453 16.7325 7.89453C16.4056 7.89453 16.1406 8.15891 16.1406 8.48503C16.1406 8.81116 16.4056 9.07553 16.7325 9.07553Z",
    fill: "url(#paint132_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4239 10.305C14.7508 10.305 15.0158 10.0406 15.0158 9.71452C15.0158 9.3884 14.7508 9.12402 14.4239 9.12402C14.097 9.12402 13.832 9.3884 13.832 9.71452C13.832 10.0406 14.097 10.305 14.4239 10.305Z",
    fill: "url(#paint133_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3497 11.9037C12.6766 11.9037 12.9416 11.6393 12.9416 11.3132C12.9416 10.987 12.6766 10.7227 12.3497 10.7227C12.0228 10.7227 11.7578 10.987 11.7578 11.3132C11.7578 11.6393 12.0228 11.9037 12.3497 11.9037Z",
    fill: "url(#paint134_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5743 13.8246C10.9012 13.8246 11.1662 13.5602 11.1662 13.2341C11.1662 12.9079 10.9012 12.6436 10.5743 12.6436C10.2474 12.6436 9.98242 12.9079 9.98242 13.2341C9.98242 13.5602 10.2474 13.8246 10.5743 13.8246Z",
    fill: "url(#paint135_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.15636 16.015C9.48326 16.015 9.74826 15.7506 9.74826 15.4245C9.74826 15.0984 9.48326 14.834 9.15636 14.834C8.82946 14.834 8.56445 15.0984 8.56445 15.4245C8.56445 15.7506 8.82946 16.015 9.15636 16.015Z",
    fill: "url(#paint136_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.10948 18.4193C8.43638 18.4193 8.70139 18.1549 8.70139 17.8288C8.70139 17.5027 8.43638 17.2383 8.10948 17.2383C7.78258 17.2383 7.51758 17.5027 7.51758 17.8288C7.51758 18.1549 7.78258 18.4193 8.10948 18.4193Z",
    fill: "url(#paint137_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.45714 20.9378C7.78404 20.9378 8.04904 20.6735 8.04904 20.3473C8.04904 20.0212 7.78404 19.7568 7.45714 19.7568C7.13024 19.7568 6.86523 20.0212 6.86523 20.3473C6.86523 20.6735 7.13024 20.9378 7.45714 20.9378Z",
    fill: "url(#paint138_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1023 11.0647C23.4619 11.0647 23.7534 10.7739 23.7534 10.4152C23.7534 10.0564 23.4619 9.76562 23.1023 9.76562C22.7427 9.76562 22.4512 10.0564 22.4512 10.4152C22.4512 10.7739 22.7427 11.0647 23.1023 11.0647Z",
    fill: "url(#paint139_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5007 11.3343C20.8603 11.3343 21.1518 11.0434 21.1518 10.6847C21.1518 10.326 20.8603 10.0352 20.5007 10.0352C20.1411 10.0352 19.8496 10.326 19.8496 10.6847C19.8496 11.0434 20.1411 11.3343 20.5007 11.3343Z",
    fill: "url(#paint140_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9948 12.1399C18.3544 12.1399 18.6459 11.8491 18.6459 11.4904C18.6459 11.1316 18.3544 10.8408 17.9948 10.8408C17.6353 10.8408 17.3438 11.1316 17.3438 11.4904C17.3438 11.8491 17.6353 12.1399 17.9948 12.1399Z",
    fill: "url(#paint141_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7234 13.4475C16.0829 13.4475 16.3745 13.1567 16.3745 12.798C16.3745 12.4393 16.0829 12.1484 15.7234 12.1484C15.3638 12.1484 15.0723 12.4393 15.0723 12.798C15.0723 13.1567 15.3638 13.4475 15.7234 13.4475Z",
    fill: "url(#paint142_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7702 15.1975C14.1298 15.1975 14.4213 14.9067 14.4213 14.548C14.4213 14.1893 14.1298 13.8984 13.7702 13.8984C13.4106 13.8984 13.1191 14.1893 13.1191 14.548C13.1191 14.9067 13.4106 15.1975 13.7702 15.1975Z",
    fill: "url(#paint143_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2136 17.3323C12.5732 17.3323 12.8647 17.0415 12.8647 16.6828C12.8647 16.324 12.5732 16.0332 12.2136 16.0332C11.854 16.0332 11.5625 16.324 11.5625 16.6828C11.5625 17.0415 11.854 17.3323 12.2136 17.3323Z",
    fill: "url(#paint144_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1491 19.7327C11.5087 19.7327 11.8002 19.4419 11.8002 19.0831C11.8002 18.7244 11.5087 18.4336 11.1491 18.4336C10.7896 18.4336 10.498 18.7244 10.498 19.0831C10.498 19.4419 10.7896 19.7327 11.1491 19.7327Z",
    fill: "url(#paint145_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5945 22.2893C10.954 22.2893 11.2455 21.9985 11.2455 21.6398C11.2455 21.281 10.954 20.9902 10.5945 20.9902C10.2349 20.9902 9.94336 21.281 9.94336 21.6398C9.94336 21.9985 10.2349 22.2893 10.5945 22.2893Z",
    fill: "url(#paint146_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5945 24.9036C10.954 24.9036 11.2455 24.6128 11.2455 24.254C11.2455 23.8953 10.954 23.6045 10.5945 23.6045C10.2349 23.6045 9.94336 23.8953 9.94336 24.254C9.94336 24.6128 10.2349 24.9036 10.5945 24.9036Z",
    fill: "url(#paint147_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1491 27.4593C11.5087 27.4593 11.8002 27.1684 11.8002 26.8097C11.8002 26.451 11.5087 26.1602 11.1491 26.1602C10.7896 26.1602 10.498 26.451 10.498 26.8097C10.498 27.1684 10.7896 27.4593 11.1491 27.4593Z",
    fill: "url(#paint148_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2136 29.8636C12.5732 29.8636 12.8647 29.5727 12.8647 29.214C12.8647 28.8553 12.5732 28.5645 12.2136 28.5645C11.854 28.5645 11.5625 28.8553 11.5625 29.214C11.5625 29.5727 11.854 29.8636 12.2136 29.8636Z",
    fill: "url(#paint149_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7507 31.9983C14.1103 31.9983 14.4018 31.7075 14.4018 31.3488C14.4018 30.99 14.1103 30.6992 13.7507 30.6992C13.3911 30.6992 13.0996 30.99 13.0996 31.3488C13.0996 31.7075 13.3911 31.9983 13.7507 31.9983Z",
    fill: "url(#paint150_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7058 33.7454C16.0654 33.7454 16.3569 33.4546 16.3569 33.0958C16.3569 32.7371 16.0654 32.4463 15.7058 32.4463C15.3462 32.4463 15.0547 32.7371 15.0547 33.0958C15.0547 33.4546 15.3462 33.7454 15.7058 33.7454Z",
    fill: "url(#paint151_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9734 35.053C18.3329 35.053 18.6245 34.7622 18.6245 34.4035C18.6245 34.0447 18.3329 33.7539 17.9734 33.7539C17.6138 33.7539 17.3223 34.0447 17.3223 34.4035C17.3223 34.7622 17.6138 35.053 17.9734 35.053Z",
    fill: "url(#paint152_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4792 35.8616C20.8388 35.8616 21.1303 35.5708 21.1303 35.2121C21.1303 34.8533 20.8388 34.5625 20.4792 34.5625C20.1196 34.5625 19.8281 34.8533 19.8281 35.2121C19.8281 35.5708 20.1196 35.8616 20.4792 35.8616Z",
    fill: "url(#paint153_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0847 36.1497C23.4443 36.1497 23.7358 35.8589 23.7358 35.5001C23.7358 35.1414 23.4443 34.8506 23.0847 34.8506C22.7251 34.8506 22.4336 35.1414 22.4336 35.5001C22.4336 35.8589 22.7251 36.1497 23.0847 36.1497Z",
    fill: "url(#paint154_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7058 35.8616C26.0654 35.8616 26.3569 35.5708 26.3569 35.2121C26.3569 34.8533 26.0654 34.5625 25.7058 34.5625C25.3462 34.5625 25.0547 34.8533 25.0547 35.2121C25.0547 35.5708 25.3462 35.8616 25.7058 35.8616Z",
    fill: "url(#paint155_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2136 35.053C28.5732 35.053 28.8647 34.7622 28.8647 34.4035C28.8647 34.0447 28.5732 33.7539 28.2136 33.7539C27.854 33.7539 27.5625 34.0447 27.5625 34.4035C27.5625 34.7622 27.854 35.053 28.2136 35.053Z",
    fill: "url(#paint156_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4831 33.7639C30.8427 33.7639 31.1342 33.4731 31.1342 33.1144C31.1342 32.7557 30.8427 32.4648 30.4831 32.4648C30.1235 32.4648 29.832 32.7557 29.832 33.1144C29.832 33.4731 30.1235 33.7639 30.4831 33.7639Z",
    fill: "url(#paint157_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4362 32.0169C32.7958 32.0169 33.0873 31.7261 33.0873 31.3673C33.0873 31.0086 32.7958 30.7178 32.4362 30.7178C32.0767 30.7178 31.7852 31.0086 31.7852 31.3673C31.7852 31.7261 32.0767 32.0169 32.4362 32.0169Z",
    fill: "url(#paint158_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9753 29.8821C34.3349 29.8821 34.6264 29.5913 34.6264 29.2326C34.6264 28.8738 34.3349 28.583 33.9753 28.583C33.6157 28.583 33.3242 28.8738 33.3242 29.2326C33.3242 29.5913 33.6157 29.8821 33.9753 29.8821Z",
    fill: "url(#paint159_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0613 27.4817C35.4208 27.4817 35.7123 27.1909 35.7123 26.8322C35.7123 26.4734 35.4208 26.1826 35.0613 26.1826C34.7017 26.1826 34.4102 26.4734 34.4102 26.8322C34.4102 27.1909 34.7017 27.4817 35.0613 27.4817Z",
    fill: "url(#paint160_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5925 24.9251C35.9521 24.9251 36.2436 24.6343 36.2436 24.2755C36.2436 23.9168 35.9521 23.626 35.5925 23.626C35.2329 23.626 34.9414 23.9168 34.9414 24.2755C34.9414 24.6343 35.2329 24.9251 35.5925 24.9251Z",
    fill: "url(#paint161_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5925 22.3108C35.9521 22.3108 36.2436 22.02 36.2436 21.6613C36.2436 21.3025 35.9521 21.0117 35.5925 21.0117C35.2329 21.0117 34.9414 21.3025 34.9414 21.6613C34.9414 22.02 35.2329 22.3108 35.5925 22.3108Z",
    fill: "url(#paint162_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0613 19.7327C35.4208 19.7327 35.7123 19.4419 35.7123 19.0831C35.7123 18.7244 35.4208 18.4336 35.0613 18.4336C34.7017 18.4336 34.4102 18.7244 34.4102 19.0831C34.4102 19.4419 34.7017 19.7327 35.0613 19.7327Z",
    fill: "url(#paint163_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9929 17.3509C34.3525 17.3509 34.644 17.06 34.644 16.7013C34.644 16.3426 34.3525 16.0518 33.9929 16.0518C33.6333 16.0518 33.3418 16.3426 33.3418 16.7013C33.3418 17.06 33.6333 17.3509 33.9929 17.3509Z",
    fill: "url(#paint164_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4538 15.2161C32.8134 15.2161 33.1049 14.9253 33.1049 14.5665C33.1049 14.2078 32.8134 13.917 32.4538 13.917C32.0942 13.917 31.8027 14.2078 31.8027 14.5665C31.8027 14.9253 32.0942 15.2161 32.4538 15.2161Z",
    fill: "url(#paint165_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5007 13.469C30.8603 13.469 31.1518 13.1782 31.1518 12.8195C31.1518 12.4607 30.8603 12.1699 30.5007 12.1699C30.1411 12.1699 29.8496 12.4607 29.8496 12.8195C29.8496 13.1782 30.1411 13.469 30.5007 13.469Z",
    fill: "url(#paint166_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2136 12.1399C28.5732 12.1399 28.8647 11.8491 28.8647 11.4904C28.8647 11.1316 28.5732 10.8408 28.2136 10.8408C27.854 10.8408 27.5625 11.1316 27.5625 11.4904C27.5625 11.8491 27.854 12.1399 28.2136 12.1399Z",
    fill: "url(#paint167_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7273 11.3343C26.0869 11.3343 26.3784 11.0434 26.3784 10.6847C26.3784 10.326 26.0869 10.0352 25.7273 10.0352C25.3677 10.0352 25.0762 10.326 25.0762 10.6847C25.0762 11.0434 25.3677 11.3343 25.7273 11.3343Z",
    fill: "url(#paint168_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3253 26.2089C14.7067 26.2089 15.0159 25.9004 15.0159 25.52C15.0159 25.1395 14.7067 24.8311 14.3253 24.8311C13.9439 24.8311 13.6348 25.1395 13.6348 25.52C13.6348 25.9004 13.9439 26.2089 14.3253 26.2089Z",
    fill: "url(#paint169_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4093 28.5917C15.7907 28.5917 16.0999 28.2833 16.0999 27.9028C16.0999 27.5223 15.7907 27.2139 15.4093 27.2139C15.0279 27.2139 14.7188 27.5223 14.7188 27.9028C14.7188 28.2833 15.0279 28.5917 15.4093 28.5917Z",
    fill: "url(#paint170_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1066 30.5712C17.488 30.5712 17.7971 30.2628 17.7971 29.8823C17.7971 29.5018 17.488 29.1934 17.1066 29.1934C16.7252 29.1934 16.416 29.5018 16.416 29.8823C16.416 30.2628 16.7252 30.5712 17.1066 30.5712Z",
    fill: "url(#paint171_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.296 31.956C19.6774 31.956 19.9866 31.6475 19.9866 31.267C19.9866 30.8866 19.6774 30.5781 19.296 30.5781C18.9146 30.5781 18.6055 30.8866 18.6055 31.267C18.6055 31.6475 18.9146 31.956 19.296 31.956Z",
    fill: "url(#paint172_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8038 32.6874C22.1852 32.6874 22.4944 32.379 22.4944 31.9985C22.4944 31.618 22.1852 31.3096 21.8038 31.3096C21.4225 31.3096 21.1133 31.618 21.1133 31.9985C21.1133 32.379 21.4225 32.6874 21.8038 32.6874Z",
    fill: "url(#paint173_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4054 32.6874C24.7868 32.6874 25.096 32.379 25.096 31.9985C25.096 31.618 24.7868 31.3096 24.4054 31.3096C24.024 31.3096 23.7148 31.618 23.7148 31.9985C23.7148 32.379 24.024 32.6874 24.4054 32.6874Z",
    fill: "url(#paint174_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9113 31.956C27.2926 31.956 27.6018 31.6475 27.6018 31.267C27.6018 30.8866 27.2926 30.5781 26.9113 30.5781C26.5299 30.5781 26.2207 30.8866 26.2207 31.267C26.2207 31.6475 26.5299 31.956 26.9113 31.956Z",
    fill: "url(#paint175_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1027 30.5712C29.484 30.5712 29.7932 30.2628 29.7932 29.8823C29.7932 29.5018 29.484 29.1934 29.1027 29.1934C28.7213 29.1934 28.4121 29.5018 28.4121 29.8823C28.4121 30.2628 28.7213 30.5712 29.1027 30.5712Z",
    fill: "url(#paint176_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8195 28.5917C31.2008 28.5917 31.51 28.2833 31.51 27.9028C31.51 27.5223 31.2008 27.2139 30.8195 27.2139C30.4381 27.2139 30.1289 27.5223 30.1289 27.9028C30.1289 28.2833 30.4381 28.5917 30.8195 28.5917Z",
    fill: "url(#paint177_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9015 26.2274C32.2829 26.2274 32.592 25.919 32.592 25.5385C32.592 25.158 32.2829 24.8496 31.9015 24.8496C31.5201 24.8496 31.2109 25.158 31.2109 25.5385C31.2109 25.919 31.5201 26.2274 31.9015 26.2274Z",
    fill: "url(#paint178_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2784 23.6503C32.6598 23.6503 32.969 23.3419 32.969 22.9614C32.969 22.5809 32.6598 22.2725 32.2784 22.2725C31.8971 22.2725 31.5879 22.5809 31.5879 22.9614C31.5879 23.3419 31.8971 23.6503 32.2784 23.6503Z",
    fill: "url(#paint179_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9015 21.0761C32.2829 21.0761 32.592 20.7676 32.592 20.3872C32.592 20.0067 32.2829 19.6982 31.9015 19.6982C31.5201 19.6982 31.2109 20.0067 31.2109 20.3872C31.2109 20.7676 31.5201 21.0761 31.9015 21.0761Z",
    fill: "url(#paint180_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8195 18.7118C31.2008 18.7118 31.51 18.4034 31.51 18.0229C31.51 17.6424 31.2008 17.334 30.8195 17.334C30.4381 17.334 30.1289 17.6424 30.1289 18.0229C30.1289 18.4034 30.4381 18.7118 30.8195 18.7118Z",
    fill: "url(#paint181_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1027 16.7509C29.484 16.7509 29.7932 16.4424 29.7932 16.062C29.7932 15.6815 29.484 15.373 29.1027 15.373C28.7213 15.373 28.4121 15.6815 28.4121 16.062C28.4121 16.4424 28.7213 16.7509 29.1027 16.7509Z",
    fill: "url(#paint182_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9113 15.329C27.2926 15.329 27.6018 15.0206 27.6018 14.6401C27.6018 14.2596 27.2926 13.9512 26.9113 13.9512C26.5299 13.9512 26.2207 14.2596 26.2207 14.6401C26.2207 15.0206 26.5299 15.329 26.9113 15.329Z",
    fill: "url(#paint183_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4249 14.5976C24.8063 14.5976 25.1155 14.2891 25.1155 13.9086C25.1155 13.5282 24.8063 13.2197 24.4249 13.2197C24.0435 13.2197 23.7344 13.5282 23.7344 13.9086C23.7344 14.2891 24.0435 14.5976 24.4249 14.5976Z",
    fill: "url(#paint184_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8038 14.5976C22.1852 14.5976 22.4944 14.2891 22.4944 13.9086C22.4944 13.5282 22.1852 13.2197 21.8038 13.2197C21.4225 13.2197 21.1133 13.5282 21.1133 13.9086C21.1133 14.2891 21.4225 14.5976 21.8038 14.5976Z",
    fill: "url(#paint185_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3175 15.329C19.6989 15.329 20.0081 15.0206 20.0081 14.6401C20.0081 14.2596 19.6989 13.9512 19.3175 13.9512C18.9361 13.9512 18.627 14.2596 18.627 14.6401C18.627 15.0206 18.9361 15.329 19.3175 15.329Z",
    fill: "url(#paint186_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1066 16.7509C17.488 16.7509 17.7971 16.4424 17.7971 16.062C17.7971 15.6815 17.488 15.373 17.1066 15.373C16.7252 15.373 16.416 15.6815 16.416 16.062C16.416 16.4424 16.7252 16.7509 17.1066 16.7509Z",
    fill: "url(#paint187_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4093 18.7118C15.7907 18.7118 16.0999 18.4034 16.0999 18.0229C16.0999 17.6424 15.7907 17.334 15.4093 17.334C15.0279 17.334 14.7188 17.6424 14.7188 18.0229C14.7188 18.4034 15.0279 18.7118 15.4093 18.7118Z",
    fill: "url(#paint188_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3234 21.0761C14.7047 21.0761 15.0139 20.7676 15.0139 20.3872C15.0139 20.0067 14.7047 19.6982 14.3234 19.6982C13.942 19.6982 13.6328 20.0067 13.6328 20.3872C13.6328 20.7676 13.942 21.0761 14.3234 21.0761Z",
    fill: "url(#paint189_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.105 17.9361C23.5082 17.9361 23.835 17.61 23.835 17.2078C23.835 16.8056 23.5082 16.4795 23.105 16.4795C22.7018 16.4795 22.375 16.8056 22.375 17.2078C22.375 17.61 22.7018 17.9361 23.105 17.9361Z",
    fill: "url(#paint190_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6187 18.5122C21.0219 18.5122 21.3487 18.1862 21.3487 17.7839C21.3487 17.3817 21.0219 17.0557 20.6187 17.0557C20.2155 17.0557 19.8887 17.3817 19.8887 17.7839C19.8887 18.1862 20.2155 18.5122 20.6187 18.5122Z",
    fill: "url(#paint191_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6245 20.1079C19.0277 20.1079 19.3546 19.7819 19.3546 19.3797C19.3546 18.9774 19.0277 18.6514 18.6245 18.6514C18.2214 18.6514 17.8945 18.9774 17.8945 19.3797C17.8945 19.7819 18.2214 20.1079 18.6245 20.1079Z",
    fill: "url(#paint192_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5015 22.3941C17.9047 22.3941 18.2315 22.068 18.2315 21.6658C18.2315 21.2636 17.9047 20.9375 17.5015 20.9375C17.0983 20.9375 16.7715 21.2636 16.7715 21.6658C16.7715 22.068 17.0983 22.3941 17.5015 22.3941Z",
    fill: "url(#paint193_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5015 24.9536C17.9047 24.9536 18.2315 24.6276 18.2315 24.2254C18.2315 23.8231 17.9047 23.4971 17.5015 23.4971C17.0983 23.4971 16.7715 23.8231 16.7715 24.2254C16.7715 24.6276 17.0983 24.9536 17.5015 24.9536Z",
    fill: "url(#paint194_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6245 27.2398C19.0277 27.2398 19.3546 26.9137 19.3546 26.5115C19.3546 26.1093 19.0277 25.7832 18.6245 25.7832C18.2214 25.7832 17.8945 26.1093 17.8945 26.5115C17.8945 26.9137 18.2214 27.2398 18.6245 27.2398Z",
    fill: "url(#paint195_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6187 28.8355C21.0219 28.8355 21.3487 28.5094 21.3487 28.1072C21.3487 27.705 21.0219 27.3789 20.6187 27.3789C20.2155 27.3789 19.8887 27.705 19.8887 28.1072C19.8887 28.5094 20.2155 28.8355 20.6187 28.8355Z",
    fill: "url(#paint196_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.105 29.4116C23.5082 29.4116 23.835 29.0856 23.835 28.6834C23.835 28.2811 23.5082 27.9551 23.105 27.9551C22.7018 27.9551 22.375 28.2811 22.375 28.6834C22.375 29.0856 22.7018 29.4116 23.105 29.4116Z",
    fill: "url(#paint197_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6089 28.8355C26.0121 28.8355 26.3389 28.5094 26.3389 28.1072C26.3389 27.705 26.0121 27.3789 25.6089 27.3789C25.2057 27.3789 24.8789 27.705 24.8789 28.1072C24.8789 28.5094 25.2057 28.8355 25.6089 28.8355Z",
    fill: "url(#paint198_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6031 27.2398C28.0062 27.2398 28.3331 26.9137 28.3331 26.5115C28.3331 26.1093 28.0062 25.7832 27.6031 25.7832C27.1999 25.7832 26.873 26.1093 26.873 26.5115C26.873 26.9137 27.1999 27.2398 27.6031 27.2398Z",
    fill: "url(#paint199_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7085 24.9536C29.1117 24.9536 29.4385 24.6276 29.4385 24.2254C29.4385 23.8231 29.1117 23.4971 28.7085 23.4971C28.3054 23.4971 27.9785 23.8231 27.9785 24.2254C27.9785 24.6276 28.3054 24.9536 28.7085 24.9536Z",
    fill: "url(#paint200_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7085 22.3941C29.1117 22.3941 29.4385 22.068 29.4385 21.6658C29.4385 21.2636 29.1117 20.9375 28.7085 20.9375C28.3054 20.9375 27.9785 21.2636 27.9785 21.6658C27.9785 22.068 28.3054 22.3941 28.7085 22.3941Z",
    fill: "url(#paint201_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6031 20.1079C28.0062 20.1079 28.3331 19.7819 28.3331 19.3797C28.3331 18.9774 28.0062 18.6514 27.6031 18.6514C27.1999 18.6514 26.873 18.9774 26.873 19.3797C26.873 19.7819 27.1999 20.1079 27.6031 20.1079Z",
    fill: "url(#paint202_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6089 18.5122C26.0121 18.5122 26.3389 18.1862 26.3389 17.7839C26.3389 17.3817 26.0121 17.0557 25.6089 17.0557C25.2057 17.0557 24.8789 17.3817 24.8789 17.7839C24.8789 18.1862 25.2057 18.5122 25.6089 18.5122Z",
    fill: "url(#paint203_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9611 25.8364C22.3969 25.8364 22.7503 25.4839 22.7503 25.0491C22.7503 24.6142 22.3969 24.2617 21.9611 24.2617C21.5252 24.2617 21.1719 24.6142 21.1719 25.0491C21.1719 25.4839 21.5252 25.8364 21.9611 25.8364Z",
    fill: "url(#paint204_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7365 23.8169C21.1723 23.8169 21.5257 23.4644 21.5257 23.0295C21.5257 22.5947 21.1723 22.2422 20.7365 22.2422C20.3006 22.2422 19.9473 22.5947 19.9473 23.0295C19.9473 23.4644 20.3006 23.8169 20.7365 23.8169Z",
    fill: "url(#paint205_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3283 25.7993C24.7641 25.7993 25.1175 25.4468 25.1175 25.0119C25.1175 24.5771 24.7641 24.2246 24.3283 24.2246C23.8924 24.2246 23.5391 24.5771 23.5391 25.0119C23.5391 25.4468 23.8924 25.7993 24.3283 25.7993Z",
    fill: "url(#paint206_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4728 23.7202C25.9087 23.7202 26.262 23.3677 26.262 22.9328C26.262 22.498 25.9087 22.1455 25.4728 22.1455C25.0369 22.1455 24.6836 22.498 24.6836 22.9328C24.6836 23.3677 25.0369 23.7202 25.4728 23.7202Z",
    fill: "url(#paint207_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2697 21.7036C24.7055 21.7036 25.0589 21.3511 25.0589 20.9162C25.0589 20.4814 24.7055 20.1289 24.2697 20.1289C23.8338 20.1289 23.4805 20.4814 23.4805 20.9162C23.4805 21.3511 23.8338 21.7036 24.2697 21.7036Z",
    fill: "url(#paint208_radial_2112_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9005 21.7407C22.3364 21.7407 22.6897 21.3882 22.6897 20.9533C22.6897 20.5185 22.3364 20.166 21.9005 20.166C21.4647 20.166 21.1113 20.5185 21.1113 20.9533C21.1113 21.3882 21.4647 21.7407 21.9005 21.7407Z",
    fill: "url(#paint209_radial_2112_7428)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.957 22.8509) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9572 22.8482) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9571 22.8509) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9562 22.8464) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9566 22.854) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9561 22.8522) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9581 22.8439) scale(50.3928 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9563 22.8468) scale(50.3928 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9561 22.8428) scale(50.3928 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9552 22.8505) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9572 22.8596) scale(50.3928 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.956 22.8586) scale(50.3928 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9593 22.8587) scale(50.3928 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.957 22.8532) scale(50.3928 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.957 22.8496) scale(50.3928 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9554 22.8481) scale(50.3928 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.956 22.8471) scale(50.3928 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9572 22.8471) scale(50.3928 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9552 22.8523) scale(50.3927 50.2732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9561 22.8415) scale(50.3928 50.2732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9563 22.8599) scale(50.3928 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9581 22.8433) scale(50.3928 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9561 22.8545) scale(50.3927 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9566 22.8527) scale(50.3927 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9579 22.8592) scale(50.3927 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9588 22.8549) scale(50.3927 50.2732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.956 22.8592) scale(50.3927 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9573 22.8527) scale(50.3928 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9559 22.8545) scale(50.3928 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9578 22.8433) scale(50.3928 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9576 22.8599) scale(50.3928 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9579 22.8415) scale(50.3927 50.2732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9548 22.8523) scale(50.3928 50.2732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9567 22.8471) scale(50.3928 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9579 22.8471) scale(50.3928 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9586 22.8481) scale(50.3927 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.957 22.8496) scale(50.3927 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.957 22.8532) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9586 22.8587) scale(50.3927 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9579 22.8586) scale(50.3928 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9567 22.8596) scale(50.3928 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9548 22.8505) scale(50.3928 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9579 22.8428) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9576 22.8468) scale(50.3928 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9578 22.8439) scale(50.3928 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9559 22.8522) scale(50.3928 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9575 22.854) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.956 22.8475) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9559 22.8455) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9564 22.8614) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9538 22.86) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9538 22.8601) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9572 22.8591) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9536 22.8631) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9553 22.8546) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9567 22.8477) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.956 22.8649) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9552 22.8499) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9569 22.8623) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9555 22.8611) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.955 22.8653) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9542 22.857) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9551 22.857) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.956 22.8653) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9557 22.8611) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.956 22.8623) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9558 22.8499) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9572 22.8649) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9564 22.8477) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9537 22.8546) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9556 22.8631) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.954 22.8591) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9552 22.8601) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9554 22.86) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9548 22.8614) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9571 22.8455) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9548 22.8521) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9554 22.8546) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9552 22.8573) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.954 22.8555) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9556 22.8515) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9537 22.86) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9564 22.8483) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9572 22.8497) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9558 22.8647) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.956 22.8524) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9557 22.8553) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.956 22.8493) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9551 22.8564) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9542 22.8564) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.955 22.8493) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9555 22.8553) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9569 22.8524) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9552 22.8647) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.956 22.8497) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9567 22.8483) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9553 22.86) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint97_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9536 22.8515) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint98_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.955 22.8555) scale(50.3928 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint99_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9538 22.8573) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint100_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9538 22.8546) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint101_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9564 22.8521) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint102_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.955 22.8652) scale(50.3927 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9563 22.8632) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint104_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9574 22.8673) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint105_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9566 22.8533) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint106_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9563 22.8638) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint107_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9571 22.8466) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint108_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9572 22.8574) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint109_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9576 22.8567) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint110_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9569 22.8631) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint111_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9561 22.8631) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint112_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9554 22.8567) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint113_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9557 22.8574) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint114_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9559 22.8466) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint115_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9567 22.8638) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint116_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9564 22.8533) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint117_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9555 22.8673) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint118_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9567 22.8643) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint119_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9541 22.8652) scale(50.3927 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint120_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9558 22.8494) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint121_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9541 22.8548) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint122_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9567 22.8568) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint123_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9555 22.8528) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint124_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9564 22.8472) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint125_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9567 22.8553) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint126_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9561 22.851) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint127_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9557 22.8627) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint128_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9554 22.8633) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint129_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9561 22.853) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint130_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9552 22.8548) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint131_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9558 22.8633) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint132_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9572 22.8615) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint133_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9571 22.851) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint134_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9545 22.8553) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint135_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9548 22.8472) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint136_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9574 22.8528) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint137_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9563 22.8557) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint138_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.955 22.8548) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint139_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9542 22.8627) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint140_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.957 22.8567) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint141_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9568 22.8553) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint142_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9543 22.8638) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint143_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9545 22.862) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint144_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9565 22.871) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint145_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9575 22.87) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint146_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9552 22.8678) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint147_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9552 22.8642) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint148_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9575 22.861) scale(50.3927 50.2732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint149_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9565 22.8639) scale(50.3927 50.2732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint150_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9547 22.8729) scale(50.3927 50.2732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint151_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9565 22.8681) scale(50.3927 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint152_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9551 22.857) scale(50.3927 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint153_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9552 22.8586) scale(50.3927 50.2732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint154_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9563 22.8711) scale(50.3928 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint155_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9533 22.8586) scale(50.3928 50.2732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint156_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9554 22.857) scale(50.3928 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint157_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9559 22.867) scale(50.3928 50.2732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint158_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9558 22.8718) scale(50.3927 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint159_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9559 22.8628) scale(50.3928 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint160_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9567 22.8638) scale(50.3928 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint161_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9552 22.866) scale(50.3927 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint162_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9552 22.8696) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint163_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9567 22.87) scale(50.3928 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint164_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9537 22.8699) scale(50.3928 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint165_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9536 22.8609) scale(50.3928 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint166_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9538 22.8656) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint167_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9554 22.8553) scale(50.3928 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint168_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.955 22.8567) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint169_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9571 22.8507) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint170_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9559 22.8518) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint171_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9564 22.863) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint172_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9558 22.8502) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint173_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9579 22.8534) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint174_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9551 22.8534) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint175_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9552 22.8502) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint176_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9566 22.863) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint177_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9569 22.8518) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint178_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9537 22.8496) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint179_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9558 22.8509) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint180_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9537 22.8552) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint181_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9569 22.853) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint182_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9566 22.8604) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint183_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9552 22.8557) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint184_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9549 22.8525) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint185_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9579 22.8525) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint186_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9576 22.8557) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint187_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9564 22.8604) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint188_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9559 22.853) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint189_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9552 22.8552) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint190_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9569 22.8449) scale(50.3928 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint191_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9566 22.8502) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint192_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9552 22.8516) scale(50.3928 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint193_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9567 22.8348) scale(50.3928 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint194_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9567 22.8552) scale(50.3928 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint195_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9552 22.8384) scale(50.3928 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint196_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9566 22.8397) scale(50.3927 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint197_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9569 22.8451) scale(50.3928 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint198_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9551 22.8397) scale(50.3928 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint199_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9565 22.8384) scale(50.3928 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint200_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9571 22.8552) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint201_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9571 22.8348) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint202_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9565 22.8516) scale(50.3928 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint203_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9551 22.8502) scale(50.3928 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint204_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9573 22.8719) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint205_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.956 22.8797) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint206_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9569 22.8741) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint207_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9571 22.8618) scale(50.3928 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint208_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9575 22.8725) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint209_radial_2112_7428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.956 22.8703) scale(50.3927 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2112_7428"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 193,
    height: 46,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeotreeLogo);
export default __webpack_public_path__ + "static/media/geotreeLogo.d94815a3483d3482953b19b9cc92c20f.svg";
export { ForwardRef as ReactComponent };